import * as React from 'react';

import { useTranslation } from 'react-i18next';

import { getBrandImage } from '@utils/get-brand-image.ts';
import { getBrandName } from '@utils/get-brand-name.ts';

import { useModals } from '@shared/contexts';

import trophy from '@assets/images/home/trophy.png';

import { Button } from '@components/button';
import { ModalName } from '@components/modals';

import { config } from '@/config.ts';

import * as Styled from './banner.styled.ts';

// ЛУТАЙ ПРИЗИ <span>З {brandName.toUpperCase()}</span> <br />
// Отримуй ХP бали за проходження <span>квестів та обмінюй їх на круті призи</span>

const Banner = () => {
	const brand = config.BRAND || 'default';
	const isXpBrand = brand === 'ngu3' || brand === 'com2';
	const { t } = useTranslation('banner');
	const { openModal } = useModals();

	const bannerImage = getBrandImage('banner');
	const brandName = getBrandName();
	const isDefaultBrand = brand === 'pm';

	const handleLoginClick = () => {
		openModal(ModalName.LOGIN);
	};

	// Для ngu3/com2 используем другой текст
	const renderTitle = () => {
		if (isXpBrand) {
			return t('home', { name: brandName.toUpperCase() });
		}

		return `${t('title1')} <span>${t('title1_hg')}</span> <br />
				${t('title2')} <span>${t('title2_hg')}</span> <br />
				${t('title3')} <span>${t('title3_hg')}</span>`;
	};

	return (
		<Styled.Wrapper>
			<Styled.Section>
				<Styled.Group>
					{isDefaultBrand && (
						<Styled.Trophy>
							<Styled.TrophyImage src={trophy} alt='trophy' />
							<Styled.TrophyTextWrapper>
								<Styled.TrophyText dangerouslySetInnerHTML={{ __html: t('trophy_title') }} />
								<Styled.TrophyText dangerouslySetInnerHTML={{ __html: t('trophy_title_hg') }} />
							</Styled.TrophyTextWrapper>
						</Styled.Trophy>
					)}
					<Styled.Title dangerouslySetInnerHTML={{ __html: renderTitle() }} />

					<Button onClick={handleLoginClick} color='primary' size='large' minWidth={104}>
						{t('button')}
					</Button>
				</Styled.Group>
				<Styled.BannerPicWrapper>
					<Styled.BannerPic src={bannerImage} />
				</Styled.BannerPicWrapper>
			</Styled.Section>
		</Styled.Wrapper>
	);
};

export default Banner;
